/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  WorkloadPlatform,
  WorkloadPlatform$inboundSchema,
} from "./workloadplatform.js";

/**
 * Every platform the catalog offers, ordered by key.
 */
export type WorkloadPlatformCatalog = {
  /**
   * The catalog entries.
   */
  platforms: Array<WorkloadPlatform>;
};

/** @internal */
export const WorkloadPlatformCatalog$inboundSchema: z.ZodMiniType<
  WorkloadPlatformCatalog,
  unknown
> = z.object({
  platforms: z.array(WorkloadPlatform$inboundSchema),
});

export function workloadPlatformCatalogFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadPlatformCatalog, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadPlatformCatalog$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadPlatformCatalog' from JSON`,
  );
}
